import {EmissionHprimDebounceDto, IEmissionWebServiceClient} from "@resources/resources";
import {Injectable} from "@angular/core";
import {Resolve} from "@angular/router";

@Injectable()
export class EmissionHprimDebounceResolver implements Resolve<EmissionHprimDebounceDto> {

  constructor(private iEmissionWebServiceClient: IEmissionWebServiceClient) {
  }

  resolve() {
    return this.iEmissionWebServiceClient.getEnabledDebounceExamen();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/emission-hprim-debounce-resolver.ts